import { useTranslation } from "next-i18next";
import { GetStaticProps } from "next";
import { useUTSLocaleContext } from "context/utsLocaleContext";
import { DrSmileUniversalFormLayout } from "layouts/pages/DrSmileUniversalFormLayout";

import { serverSideTranslations } from "utils/next/translations";
import content from "content/drSmileUniversalForm";
import { checkIsNotFound } from "configs/unsupport-locale-routes";
import { UrlsConfig } from "configs/urlsConfig";
import { CustomTheme } from "constants/enum";

export default function DrSmileUniversalForm() {
    const { t } = useTranslation("global");
    const { locale } = useUTSLocaleContext();

    const pageContent = content(locale)(t, { locale });

    return <DrSmileUniversalFormLayout {...pageContent} />;
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
    if (checkIsNotFound(UrlsConfig.DRSMILE_LEADFORM, locale)) {
        return {
            notFound: true,
        };
    }

    return {
        props: {
            ...(await serverSideTranslations(locale, [
                "drSmile",
                "universalForm",
                "common-form",
                "commonVerification",
            ])),
            key: locale,
            withHeader: false,
            withFooter: false,
            theme: CustomTheme.DRSMILE,
        },
    };
};
